import { render, staticRenderFns } from "./select-goods_type.vue?vue&type=template&id=0bd317ef"
import script from "./select-goods_type.vue?vue&type=script&lang=ts"
export * from "./select-goods_type.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports